import MultiSelectOptions from "./MultiSelectOptions";
import ResourceLinkCard from "./ResourceLinkCard";
import SingleSelectOptions from "./SingleSelectOptions";
import ThinkingIndicator from "./ThinkingIndicator";
import Markdown from "@app/components/Markdown/Markdown";
import type { ResponseItem } from "@app/config/agentWebSocket";
import type { ChatMessage } from "@lib/agent/types";
import { Box, Paper, Text } from "@mantine/core";

function ExtraItem({ item, onSend }: { item: ResponseItem; onSend: (v: string) => void }) {
  switch (item.action) {
    case "resource_link":
      return <ResourceLinkCard label={item.resource_link.label} url={item.resource_link.url} />;
    case "question_select_multi":
      return <MultiSelectOptions options={item.options} onSend={onSend} />;
    case "question_select_single":
      return <SingleSelectOptions options={item.options} onSend={onSend} />;
    case "question_open":
    default:
      return null;
  }
}

export default function AgentChatMessage({
  message,
  isStreaming,
  onSend
}: {
  message: ChatMessage;
  isStreaming: boolean;
  onSend: (v: string) => void;
}) {
  const isUser = message.role === "user";

  return (
    <Box
      style={{
        alignSelf: isUser ? "flex-end" : "flex-start"
      }}
    >
      <Paper
        py={0}
        px={0}
        radius="sm"
        bg={isUser ? "var(--mantine-color-gray-light-hover)" : "transparent"}
        shadow={isUser ? "xxs" : "none"}
        withBorder={isUser}
      >
        {isUser ? (
          <Text size="sm" fw={600}>
            {message.content}
          </Text>
        ) : (
          <Markdown>{message.content}</Markdown>
        )}

        {isStreaming && !message.content && <ThinkingIndicator />}
      </Paper>
      {message.extras?.map((item, i) => (
        <ExtraItem key={i} item={item} onSend={onSend} />
      ))}
    </Box>
  );
}
